
import axios from "axios";
import {SEA_TURTLE_WEB_API} from "@/constants/appConstant";

export const getAllImage = async (page, pageSize, keyword) => {
    let result = null;
    try {
        result = await axios({
            url: `${SEA_TURTLE_WEB_API}/images`,
            params: {
                page: page,
                size: pageSize,
                keyword: keyword,
            },
            headers: {
                Accept: "application/json",
            },
            method: "GET",

        })
    } catch (e) {
        console.error(e);
    }
    return result;
}

export const saveImages = async (img) => {
    let result = null;
    try {
        result = await axios({
            method: "post",
            url: `${SEA_TURTLE_WEB_API}/images`,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            data: {
                topicName: img.topicName,
                name: img.name,
                desc: img.desc,
                link: img.link,
                imageCategory: img.imageCategory,
                year : img.year
            },
        })
    } catch (e) {
        console.error(e);
    }
    return result;
}

export const uploadImage = async (uploadDir, imgName, imgFile) => {
    let response = null;
    try {
        let parametersUrl = `?uploadDir=${uploadDir}&imgName=${imgName}`;
        response = await axios.post(`${SEA_TURTLE_WEB_API}/images/upload${parametersUrl}`, imgFile, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });
    } catch (error) {
        console.error('Error uploading image: ', error);
    }
    return response?.data.data
}

export const getAllImageWithoutPaging = async (keyword, page, year) => {
    let result = null;
    try {
        result = await axios({
            url: `${SEA_TURTLE_WEB_API}/images/all`,
            params: {
                keyword: keyword,
                page : page,
                year : year
            },
            headers: {
                Accept: "application/json",
            },
            method: "GET",

        })
    } catch (e) {
        console.error(e);
    }
    return result;
}

export const deleteImg = async (id) => {
    let result = null;
    try {
        result = await axios({
            url: `${SEA_TURTLE_WEB_API}/images/${id}`,
            headers: {
                Accept: "application/json",
            },
            method: "DELETE",

        })
    } catch (e) {
        console.error(e);
    }
    return result?.status;
}

export const getImgById = async (id) => {
    let result = null;
    try {
        result = await axios({
            url: `${SEA_TURTLE_WEB_API}/images/${id}`,
            headers: {
                Accept: "application/json",
            },
            method: "GET",

        })
    } catch (e) {
        console.error(e);
    }
    return result?.data.data;
}

export const updateImage = async (data) => {
    let token = localStorage.getItem("token");
    let result = null;
    try {
        result = await axios.put(`${SEA_TURTLE_WEB_API}/images`, data, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
    }
}

export async function getBaners(type) {
  try {
    const res = await fetch(
         `${SEA_TURTLE_WEB_API}/images/banners?type=${type}`,
      {
        next: { revalidate: 3600 },
      }
    );

    if (!res.ok) return [];

    const data = await res.json();
    return data?.data || [];
  } catch {
    return [];
  }
}

export const updateBanner = async (data) => {
    let token = localStorage.getItem("token");
    let result = null;
    try {
        result = await axios.put(`${SEA_TURTLE_WEB_API}/images/banner`, data, {
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: "Bearer " + token
            }
        });
    } catch (e) {
        console.error(e);
    }
}

export const saveBanners = async (img) => {
    let result = null;
    try {
        result = await axios({
            method: "post",
            url: `${SEA_TURTLE_WEB_API}/images/banner`,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            data: {
                name: img.name,
                desc: img.desc,
                link: img.link,
                linkToPost : img.linkToPost,
                type : img.type
            },
        })
    } catch (e) {
        console.error(e);
    }
    return result;
}